<template>
  <div>
    <el-card class="prodinfo--card">
      <z-search :configs="configs" v-model="searchData" ref="search" @do-query="query"></z-search>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button @click="exportOrder" :loading="exportLoading" class="mb-16" v-auth="'storage::out-stock::export'">
        {{ $t('storage::out-stock::export') }}
      </el-button>
      <z-table
        :columns="tableColumns"
        :data="tableData"
        :max-height="500"
        v-loading="loading"
        :pagination.sync="pagination"
        class="prodinfo--table"
        @page-change="handlePageChange"
      >
        <template #skuId="{row}">
          <span>{{ row.skuId }}{{ row.skuProperty ? '-' + row.skuProperty : '' }}</span>
        </template>
        <template #title="{row}">
          <div class="prodinfo--table__imgTd">
            <el-popover placement="top-start" trigger="hover">
              <ZImg :src="row.img" style="width: 250px;height: 250px"></ZImg>
              <ZImg :src="row.img" style="width: 50px;height: 50px;margin-right:10px" slot="reference"></ZImg>
            </el-popover>
            <div>
              <div>{{ row.title }}</div>
              <div>{{ row.categoryName }}</div>
            </div>
          </div>
        </template>
      </z-table>
    </el-card>
  </div>
</template>

<script>
import { outSearchConfig, OUT_STORAGE_DETAIL_COLUMNS, ORDER_STATUS } from './config'
import { getSupplierList } from '@/server/product'
import { getStockOrderList, getUserList, exportStockOrder } from '@/server/stock'
import { downloadBlobFile } from '@/utils'
import { getDicByCode } from '@/server/common'
import moment from 'moment'
export default {
  data() {
    return {
      configs: outSearchConfig(),
      searchData: {},
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0
      },
      orderStatus: ORDER_STATUS,
      tableColumns: OUT_STORAGE_DETAIL_COLUMNS,
      tableData: [],
      loading: false,
      exportLoading: false
    }
  },
  mounted() {
    this.getOutStorageConfig()
    this.handlePageChange()
  },
  methods: {
    async getOutStorageConfig() {
      let supplierList = []
      let shopUserList = []
      let typeList = []
      const supplier = await getSupplierList({
        page_num: 1,
        status: 1,
        page_size: 10000
      })
      const shopUser = await getUserList()
      supplierList = supplier.data.data.items.map(item => {
        return { label: item.name, value: item.id }
      })
      shopUserList = shopUser.data.data.map(item => {
        return { label: item.userName, value: item.userId }
      })
      const { data } = await getDicByCode(7)
      if (data.code === this.$code) {
        typeList = data.data.map(item => {
          return { label: this.$t(`system::outStock::type::${item.name}`), value: item.id }
        })
      }
      this.configs = outSearchConfig(supplierList, shopUserList, typeList)
    },
    query(data) {
      this.pagination.pageNum = 1
      this.getTableData(data)
    },
    async getTableData(d) {
      const params = {
        ...this.pagination,
        type: 2,
        ...d
      }
      delete params.total
      this.loading = true
      const { data } = await getStockOrderList(params)
      if (data.code === this.$code) {
        this.tableData = data.data.items
        this.pagination.total = data.data.totalCount
      }
      this.loading = false
    },
    handlePageChange() {
      this.$nextTick(() => {
        const params = this.$refs.search.getSearchParams()
        this.getTableData(params)
      })
    },
    async exportOrder() {
      let params = this.$refs.search.getSearchParams()
      this.exportLoading = true
      const res = await exportStockOrder({
        ...params,
        type: 2
      })
      this.exportLoading = false
      if (res.code === this.$code) {
        downloadBlobFile(
          res.response.data,
          {
            type: 'application/csv;charset=UTF-8'
          },
          `products_${moment().format('YYYYMMDD')}.csv`
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
}
.prodinfo--table {
  &__imgTd {
    display: flex;
    align-items: center;
    padding: 10px 0;
    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
  }
}
</style>
